import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var BlockerInlineStyles = /*#__PURE__*/function () {
  function BlockerInlineStyles() {
    _classCallCheck(this, BlockerInlineStyles);
  }

  _createClass(BlockerInlineStyles, null, [{
    key: "topSide",
    value: function topSide(_ref) {
      var antiAdBlocker = _ref.customCss.antiAdBlocker;
      var style = {
        marginBottom: 20
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-tb-top",
        style: style
      };
    }
  }, {
    key: "bottomSide",
    value: function bottomSide(_ref2) {
      var bg = _ref2.design.bg,
          antiAdBlocker = _ref2.customCss.antiAdBlocker;
      var style = {
        background: bg
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-tb-bottom",
        style: style
      };
    }
  }, {
    key: "infoText",
    value: function infoText(_ref3) {
      var fontColor = _ref3.design.fontColor,
          antiAdBlocker = _ref3.customCss.antiAdBlocker;
      var style = {
        fontStyle: "italic",
        color: fontColor,
        fontSize: 14,
        opacity: 0.5
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-tb-info-text",
        style: style
      };
    }
  }]);

  return BlockerInlineStyles;
}();

export { BlockerInlineStyles };